/** enum for rating types */
export enum RatingTypes {
    thumbs = 'thumbs',
    nps = 'nps'
}